import { GetModuleUsageResponseRecord, GetModuleUsageResponse } from '../../types/routes/module';

import { makeRequest } from '.';
import { routes } from '../../types/routes';
import { URL_QUERY_ARRAY_JOINER } from '../utils/query';

export type Filters = {
  institutions: number[];
  classes: number[];
  start?: Date | null;
  end?: Date | null;
  strategy?: string | null;
  state?: string[] | null;
};

// Six months ago (180 days)
export const makeFilter = (recentDays = 180): Filters => {
  // Within the last six months or after the most recent August 1.
  const now = new Date();
  // January is month 0
  const mostRecentAugustFirst = new Date(
    (now.getUTCMonth() < 7 ? now.getUTCFullYear() - 1 : now.getUTCFullYear()) + '-08-01',
  );
  const recentStart = new Date(now.getTime() - recentDays * 24 * 3600 * 1000);
  return {
    institutions: [],
    classes: [],
    start: mostRecentAugustFirst > recentStart ? recentStart : mostRecentAugustFirst,
    end: null,
  };
};

export const getModuleUsage = async (filters: Filters, debug: string | null): Promise<GetModuleUsageResponse> => {
  const query = new URLSearchParams();
  if (filters.institutions.length > 0) query.append('institutions', filters.institutions.join(URL_QUERY_ARRAY_JOINER));
  if (filters.classes.length > 0) query.append('classes', filters.classes.join(URL_QUERY_ARRAY_JOINER));
  if (debug) query.append('debug', debug);

  // ISO 8601 date only strings are treated as UTC
  if (filters.start) query.append('start', filters.start.toISOString());
  if (filters.end) query.append('end', filters.end.toISOString());
  if (filters.strategy) query.append('strategy', filters.strategy);
  if (filters.state) query.append('state', filters.state.join(URL_QUERY_ARRAY_JOINER));
  const response = await makeRequest(routes.getModuleUsage.method, routes.getModuleUsage.path + '?' + query);
  return GetModuleUsageResponseRecord.check(response.data);
};
